import {Injectable} from '@angular/core';
import {SETTINGS} from "../config/common.settings";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class OpenAiService {

  getGeneratedContent: any;
  onGetGeneratedContentChange: Subject<any> = new BehaviorSubject({});
  onGetGeneratedHighlightContentChange: Subject<any> = new BehaviorSubject({});

  constructor(private http: HttpClient) {
  }

  askChatGPT(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/ai/generate-content`, payload)
        .subscribe({
          next: (response: any) => {
            this.getGeneratedContent = response;
            this.onGetGeneratedContentChange.next(this.getGeneratedContent);
            resolve(this.getGeneratedContent);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  askChatGPTGeneral(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/ai/generate-content`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  generateContract(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/ai/generate-contract`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  generateMiniContent(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/ai/generate-mini-content`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
}
